// extracted by mini-css-extract-plugin
module.exports = {"marginBefore":"AddressInformation_marginBefore__2Kx_R"};